import React from 'react';
export function Modulo3Page() {
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-844">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-845">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-846">
          AI <span className="text-[#F5C842]" data-id="element-847">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-848">
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-849">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-850">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-851">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-852">
            Módulo 4
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] md:pb-[50px]" data-id="element-853">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-854">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-855">
            Módulo 3 de 4
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-856">
            ⏱ 20 minutos · Herramienta: Sales Letter Weapon
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-857">
          La Demo que
          <br data-id="element-858" />
          <span className="text-[#F5C842]" data-id="element-859">Cierra Sola</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-860">
          Cómo construir un sitio web profesional para tu prospecto en menos de
          10 minutos — antes de hablar con él. Cuando llegas con la demo lista,
          ya no eres un vendedor. Eres un consultor.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-861">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-862">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-863"></div>
            Herramienta: Sales Letter Weapon en HEYLLOYD
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-864">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-865"></div>
            Demo lista en menos de 2 minutos
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-866">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-867"></div>5 demos
            listas para presentar
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-868">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-869">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-870">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-871"></span>
            Video del Módulo
          </div>
          <a href="#" className="group block overflow-hidden rounded-[10px] border-2 border-[#1e1e1e] transition-all duration-250 hover:-translate-y-0.5 hover:border-[#F5C842]" data-id="element-872">
            <div className="relative flex h-[280px] flex-col items-center justify-center overflow-hidden" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 40px, rgba(245,200,66,0.015) 40px, rgba(245,200,66,0.015) 41px), linear-gradient(135deg, #0d0d0d 0%, #141414 50%, #0a0a0a 100%)'
          }} data-id="element-873">
              <div className="absolute inset-x-0 bottom-0 h-[80px] bg-gradient-to-t from-black/60 to-transparent" data-id="element-874"></div>
              <div className="relative z-10 mb-5 flex h-[80px] w-[80px] items-center justify-center rounded-full border-[3px] border-[#F5C842]" data-id="element-875">
                <div style={{
                width: 0,
                height: 0,
                borderTop: '14px solid transparent',
                borderBottom: '14px solid transparent',
                borderLeft: '24px solid #F5C842',
                marginLeft: '6px'
              }} data-id="element-876"></div>
              </div>
              <div className="relative z-10 px-10 text-center font-heading text-[20px] font-black text-white" data-id="element-877">
                MÓDULO 3 — La Demo que Cierra Sola
              </div>
              <div className="relative z-10 mt-2 text-[11px] text-[#555]" data-id="element-878">
                Haz clic para ver el video en Google Drive
              </div>
            </div>
            <div className="flex items-center justify-between bg-[#F5C842] px-6 py-3" data-id="element-879">
              <span className="font-heading text-[11px] font-black tracking-[1px] text-black uppercase" data-id="element-880">
                ▶ Ver Video Completo — Google Drive
              </span>
              <span className="font-heading text-[16px] font-black text-black" data-id="element-881">
                →
              </span>
            </div>
          </a>
        </div>

        {/* STRATEGY BANNER */}
        <div className="mb-8 rounded-r-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-gradient-to-br from-[#0d0d0d] to-[#111] px-7 py-6" data-id="element-882">
          <div className="mb-2 font-heading text-[16px] font-black text-[#F5C842]" data-id="element-883">
            ⚡ La Estrategia que Cambia Todo
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-884">
            La razón por la que la mayoría falla vendiendo servicios digitales
            es que llegan con palabras:{' '}
            <strong className="text-white" data-id="element-885">
              "Te puedo hacer un sitio web."
            </strong>{' '}
            El cliente no lo ve. No lo cree. Y no compra.
            <br data-id="element-886" />
            <br data-id="element-887" />
            Con este módulo, llegas a la llamada con el sitio web del cliente{' '}
            <strong className="text-white" data-id="element-888">ya construido</strong>. El cliente lo
            ve, le gusta, y la venta se cierra sola. Tú no convences — tú
            muestras.
          </div>
        </div>

        {/* TOOL HIGHLIGHT */}
        <div className="mb-8 flex flex-col md:flex-row gap-6 items-start rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black px-6 py-7 md:px-8" data-id="element-889">
          <div className="text-[48px] leading-none shrink-0" data-id="element-890">🧠</div>
          <div data-id="element-891">
            <div className="mb-1.5 font-heading text-[8px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-892">
              Heylloyd — Cerebro de IA
            </div>
            <div className="mb-2 font-heading text-[24px] font-black text-white" data-id="element-893">
              Sales Letter Weapon
            </div>
            <div className="max-w-[700px] text-[13px] leading-[1.7] text-[#888]" data-id="element-894">
              La IA que construye el sitio web del cliente en minutos. Le das la
              información básica del negocio y ella genera una página
              profesional completa, lista para presentar como demo antes de la
              llamada de venta.
            </div>
          </div>
        </div>

        {/* HOW TO BUILD A DEMO */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-895">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-896"></span>
          Cómo Construir una Demo en 5 Pasos
        </div>
        <div className="mb-8 flex flex-col gap-3" data-id="element-897">
          {[{
          num: '1',
          title: 'Abre Sales Letter Weapon en HEYLLOYD',
          desc: 'Selecciona el cerebro "Sales Letter Weapon" desde tu panel de HEYLLOYD'
        }, {
          num: '2',
          title: 'Ingresa el nombre del negocio',
          desc: 'El nombre exacto del negocio que encontraste en el Módulo 2 con Ai Website Arbitrage'
        }, {
          num: '3',
          title: 'Ingresa tipo de negocio, ciudad y servicios',
          desc: 'Toda esta información ya la tienes de tu lista de prospectos del Módulo 2'
        }, {
          num: '4',
          title: 'Ingresa el número de teléfono del negocio',
          desc: 'La IA lo incluirá en la sección de contacto del sitio generado'
        }, {
          num: '5',
          title: 'Copia y guarda el link de la demo',
          desc: 'En menos de 2 minutos tendrás una página profesional lista para enviar al cliente'
        }].map(step => <div key={step.num} className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-898">
              <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-899">
                {step.num}
              </div>
              <div data-id="element-900">
                <div className="mb-[3px] text-[13px] font-bold text-white" data-id="element-901">
                  {step.title}
                </div>
                <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-902">
                  {step.desc}
                </div>
              </div>
            </div>)}
        </div>

        {/* WHAT IT GENERATES */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-903">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-904"></span>
          Qué Genera Sales Letter Weapon Automáticamente
        </div>
        <div className="mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3" data-id="element-905">
          {[{
          icon: '🎨',
          label: 'Logo del negocio'
        }, {
          icon: '📝',
          label: 'Descripción de servicios'
        }, {
          icon: '🖼️',
          label: 'Galería de fotos'
        }, {
          icon: '📍',
          label: 'Sección de contacto y mapa'
        }, {
          icon: '📱',
          label: 'Diseño responsive móvil'
        }].map(item => <div key={item.label} className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-906">
              <div className="mb-2 text-[24px]" data-id="element-907">{item.icon}</div>
              <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-908">
                {item.label}
              </div>
            </div>)}
        </div>

        {/* INFO NEEDED — TWO COLUMN CARDS */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-909">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-910">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-911">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-912"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-913">
                Información que necesitas del negocio
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-914">
              <ul className="flex flex-col" data-id="element-915">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-916">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-917">
                    →
                  </span>
                  <strong className="text-white" data-id="element-918">Nombre del negocio</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-919">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-920">
                    →
                  </span>
                  <span data-id="element-921">
                    <strong className="text-white" data-id="element-922">Tipo de negocio</strong>{' '}
                    (restaurante, peluquería, etc.)
                  </span>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-923">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-924">
                    →
                  </span>
                  <strong className="text-white" data-id="element-925">Ciudad y dirección</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1.5" data-id="element-926">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-927">
                    →
                  </span>
                  <strong className="text-white" data-id="element-928">Servicios que ofrece</strong>
                </li>
                <li className="flex items-start gap-2 py-1.5" data-id="element-929">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-930">
                    →
                  </span>
                  <strong className="text-white" data-id="element-931">Número de teléfono</strong>
                </li>
              </ul>
              <div className="mt-4 text-[11px] italic text-[#555]" data-id="element-932">
                ✓ Todo esto lo encontraste en el Módulo 2 con Ai Website
                Arbitrage
              </div>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-933">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-934">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-935"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-936">
                ¿Tiene que ser perfecta la demo?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-937">
              <strong className="text-white" data-id="element-938">No.</strong> No tiene que ser
              perfecta. Tiene que ser{' '}
              <strong className="text-white" data-id="element-939">
                profesional y mucho mejor que lo que tienen ahora
              </strong>
              . Eso es todo lo que necesitas para cerrar la venta.
              <br data-id="element-940" />
              <br data-id="element-941" />
              Cuando el cliente ve su negocio representado de forma profesional
              en pantalla, la conversación cambia completamente. Ya no estás
              vendiendo — estás{' '}
              <strong className="text-white" data-id="element-942">
                mostrando el resultado final
              </strong>
              .
            </div>
          </div>
        </div>

        {/* SCRIPT */}
        <div className="mb-8" data-id="element-943">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-944">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-945"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-946">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-947">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-948"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-949">
              "Módulo 3. Este es el módulo que más me emociona enseñarte. Voy a
              mostrarte cómo construir un sitio web profesional para tu
              prospecto en menos de 10 minutos, antes de hablar con él. Cuando
              llegues a la llamada con una demo ya lista, la conversación cambia
              completamente. Ya no eres un vendedor. Eres un consultor que ya
              hizo el trabajo."
            </div>
          </div>

          <div className="mb-4" data-id="element-950">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-951">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-952"></span>⏱
              0:30 – 15:00 · Demo en Pantalla
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-953">
              "Abre el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-954">
                'Sales Letter Weapon'
              </span>{' '}
              en HEYLLOYD. Vas a ver que te pide información básica del negocio:
              nombre, tipo de negocio, ciudad, servicios que ofrece y número de
              teléfono. Toda esa información la encontraste en el Módulo 2 con
              el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-955">
                'Ai Website Arbitrage'
              </span>
              ."
              <br data-id="element-956" />
              <br data-id="element-957" />
              "Rellena los campos con la información de tu primer prospecto.
              Ahora observa. En menos de 2 minutos, el cerebro genera una página
              web completa con: el logo del negocio, una descripción de sus
              servicios, una galería de fotos, y una sección de contacto con su
              teléfono y mapa."
              <br data-id="element-958" />
              <br data-id="element-959" />
              "¿Es perfecta? No. ¿Es profesional y mucho mejor que lo que tienen
              ahora? Absolutamente. Y eso es todo lo que necesitas para cerrar
              la venta."
              <br data-id="element-960" />
              <br data-id="element-961" />
              "Guarda el link de la demo. En el Módulo 4, te voy a enseñar
              exactamente qué decir cuando llames a este negocio."
            </div>
          </div>

          <div className="mb-4" data-id="element-962">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-963">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-964"></span>⏱
              15:00 – 20:00 · Cierre y Tarea
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-965">
              "Tarea: construye una demo para cada uno de tus 5 prospectos.
              Guarda el link de cada una. Cuando tengas las 5 demos listas,
              estás listo para el Módulo 4 y para hacer tu primera venta."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-966">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-967">
            ✅ Tu Tarea — Módulo 3
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-968">
            Usa <strong className="text-white" data-id="element-969">Sales Letter Weapon</strong> en
            HEYLLOYD y construye una demo para cada uno de tus{' '}
            <strong className="text-white" data-id="element-970">5 prospectos</strong>. No hagas
            ninguna llamada sin tener la demo lista primero.
            <div className="mt-3 flex flex-col gap-2" data-id="element-971">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-972">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-973">
                  1
                </div>
                Abre HEYLLOYD y selecciona el cerebro "Sales Letter Weapon"
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-974">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-975">
                  2
                </div>
                Ingresa la información del Prospecto #1 (nombre, tipo, ciudad,
                servicios, teléfono)
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-976">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-977">
                  3
                </div>
                Copia y guarda el link de la demo generada
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-978">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-979">
                  4
                </div>
                Repite para los 5 prospectos de tu lista
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-980">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-981">
                  5
                </div>
                <strong className="text-white" data-id="element-982">
                  Cuando tengas las 5 demos listas, pasa al Módulo 4
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-983">
        <a href="/modulo-2" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] transition-colors hover:text-white" data-id="element-984">
          ← Módulo 2
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-985">
          AI <span className="text-[#F5C842]" data-id="element-986">WEB CLOSER</span>
        </div>
        <a href="/modulo-4" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-987">
          Módulo 4: El Cierre Sin Presión →
        </a>
      </div>
    </div>;
}